import { ProductSpecificationDto } from "../../product-models";
import { Action, ActionType } from "../actionTypes"

interface specState {
    loaded: boolean,
    pending: boolean,
    specificationsData: ProductSpecificationDto,
    error: string,
}

const initialState:specState = {
    loaded: false,
    pending: false,
    specificationsData: null,
    error: null,
}

const specReducer = (state: specState = initialState, action: Action):specState => {
    switch (action.type) {
        case ActionType.REQUEST_SPEC_DATA:
            console.log("Req specs fired")
            return { ...state, pending: true }
        case ActionType.RECEIVE_SPEC_DATA:
            return {
                ...state,
                specificationsData: action.payload,
                pending: false,
                loaded: true
            }
        case ActionType.EXPAND_ALL_SPECS:
            return {
                ...state,
                specificationsData: {
                    ...state.specificationsData,
                    SpecCollections: state.specificationsData.SpecCollections.map(c => {
                        return {
                            ...c,
                            IsExpanded: true
                        }
                    })
                }
            }
        case ActionType.COLLAPSE_ALL_SPECS:
            return {
                ...state,
                specificationsData: {
                    ...state.specificationsData,
                    SpecCollections: state.specificationsData.SpecCollections.map(c => {
                        return {
                            ...c,
                            IsExpanded: false
                        }
                    })
                }
            }
        case ActionType.EXPAND_SPEC:
            return {
                ...state,
                specificationsData: {
                    ...state.specificationsData,
                    //find the spec collection and set it to expanded
                    SpecCollections: state.specificationsData.SpecCollections.map(c => {
                        if(c.CollectionName == action.payload) {
                            return {
                                ...c,
                                IsExpanded: true
                            }
                        }
                        return c
                    }),
                }
            }
        case ActionType.COLLAPSE_SPEC:
            return {
                ...state,
                specificationsData: {
                    ...state.specificationsData,
                    //find the spec collection and set it to expanded
                    SpecCollections: state.specificationsData.SpecCollections.map(c => {
                        if(c.CollectionName == action.payload) {
                            return {
                                ...c,
                                IsExpanded: false
                            }
                        }
                        return c
                    }),
                }
            }
        default:
            return state
    }
}

export default specReducer;